import { Typography, Button } from '../kit';
import { themeColors } from '../theme/theme';

export default function NoQuote({ onGetStarted }) {
  return (
    <div
      style={{
        background: `linear-gradient(135deg, ${themeColors.backgroundColor} 70%, ${themeColors.primaryColor}11 100%)`,
        borderRadius: 12,
        margin: '1.5em 0',
        padding: '2em 1em',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        // boxShadow: `0 4px 32px 0 ${themeColors.primaryColor}22, 0 1.5px 8px 0 ${themeColors.primaryColor}33`,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          justifyContent: 'center',
          width: '100%',
          marginBottom: 60,
        }}
      >
        <Typography
          type="h1"
          style={{
            color: themeColors.primaryColor,
            fontWeight: 900,
            fontSize: 96,
            lineHeight: 1,
            marginRight: 32,
            alignSelf: 'center',
            textTransform: 'uppercase',
            letterSpacing: 1.5,
          }}
          text="No"
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '96px',
            gap: 16,
          }}
        >
          <Typography
            type="h4"
            style={{
              color: themeColors.primaryColor,
              fontWeight: 700,
              fontSize: 24,
              textTransform: 'uppercase',
              letterSpacing: 1.2,
              lineHeight: 1.1,
            }}
            text="Warehouse"
          />
          <Typography
            type="h4"
            style={{
              color: themeColors.primaryColor,
              fontWeight: 700,
              fontSize: 24,
              textTransform: 'uppercase',
              letterSpacing: 1.2,
              lineHeight: 1.1,
            }}
            text="Hub"
          />
          <Typography
            type="h4"
            style={{
              color: themeColors.primaryColor,
              fontWeight: 700,
              fontSize: 24,
              textTransform: 'uppercase',
              letterSpacing: 1.2,
              lineHeight: 1.1,
            }}
            text="Waiting"
          />
        </div>
      </div>
      <Button
        variant="contained"
        style={{
          background: themeColors.primaryColor,
          color: themeColors.backgroundColor,
          fontWeight: 400,
          borderRadius: 8,
          padding: '0.75em 2em',
          fontSize: 18,
          textTransform: 'normal',
          boxShadow: '0 2px 8px #0001',
        }}
        onClick={onGetStarted || (() => alert('Get Started!'))}
      >
        Keep it moving
      </Button>
    </div>
  );
}
